/**
 * @generated SignedSource<<034e680b4a834955a68a26113be4895d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateHolidayCalendarEntryInput = {
  id: string;
  name?: string | null;
  year?: number | null;
  month?: number | null;
  day?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateHolidayCalendarEntryMutation$variables = {
  input: UpdateHolidayCalendarEntryInput;
};
export type updateHolidayCalendarEntryMutation$data = {
  readonly updateHolidayCalendarEntry: {
    readonly holidayCalendarEntry: {
      readonly " $fragmentSpreads": FragmentRefs<"settingsHolidayCalendars_holidayCalendarEntry">;
    } | null;
  } | null;
};
export type updateHolidayCalendarEntryMutation = {
  variables: updateHolidayCalendarEntryMutation$variables;
  response: updateHolidayCalendarEntryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateHolidayCalendarEntryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateHolidayCalendarEntryPayload",
        "kind": "LinkedField",
        "name": "updateHolidayCalendarEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HolidayCalendarEntry",
            "kind": "LinkedField",
            "name": "holidayCalendarEntry",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "settingsHolidayCalendars_holidayCalendarEntry"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateHolidayCalendarEntryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateHolidayCalendarEntryPayload",
        "kind": "LinkedField",
        "name": "updateHolidayCalendarEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HolidayCalendarEntry",
            "kind": "LinkedField",
            "name": "holidayCalendarEntry",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "year",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "month",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "day",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9313d445baebddaef6684e124dcd03a0",
    "id": null,
    "metadata": {},
    "name": "updateHolidayCalendarEntryMutation",
    "operationKind": "mutation",
    "text": "mutation updateHolidayCalendarEntryMutation(\n  $input: UpdateHolidayCalendarEntryInput!\n) {\n  updateHolidayCalendarEntry(input: $input) {\n    holidayCalendarEntry {\n      ...settingsHolidayCalendars_holidayCalendarEntry\n      id\n    }\n  }\n}\n\nfragment settingsHolidayCalendars_holidayCalendarEntry on HolidayCalendarEntry {\n  id\n  name\n  year\n  month\n  day\n}\n"
  }
};
})();

(node as any).hash = "22d8184b21bb3b9d6980a5fdbd8d80d4";

export default node;
